// jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Splide
import Splide from '@splidejs/splide';
window.Splide = Splide;

// Wow.js
import { WOW } from 'wowjs';
window.WOW = WOW;

// Light Gallery
import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
window.lightGallery = lightGallery;
window.lgFullscreen = lgFullscreen;
window.lgThumbnail = lgThumbnail;

// Base Scripts
$(() => {
    import('./main/base');
});
